var _g, _rect, _rect2, _g2, _g3, _rect3, _rect4, _rect5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlacard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_715_15987)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.8438,
    y: 1.92401,
    width: 6.1742,
    height: 28.139,
    rx: 3.0871,
    fill: "url(#paint0_linear_715_15987)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.8438,
    y: 1.92401,
    width: 6.1742,
    height: 28.139,
    rx: 3.0871,
    fill: "url(#paint1_radial_715_15987)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.8438,
    y: 1.92401,
    width: 6.1742,
    height: 28.139,
    rx: 3.0871,
    fill: "url(#paint2_radial_715_15987)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8438,
    y: 1.92401,
    width: 6.1742,
    height: 28.139,
    rx: 3.0871,
    fill: "url(#paint3_radial_715_15987)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_715_15987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1758 19.4514V18.3243H18.8234V19.4514C16.6644 19.0592 14.4659 19.2307 13.1758 19.4514Z",
    fill: "#A86650"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_iii_715_15987)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.94531,
    y: 5.04065,
    width: 21.9648,
    height: 13.9758,
    rx: 2.1,
    fill: "url(#paint4_linear_715_15987)"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9336,
    y: 8.00946,
    width: 9.96157,
    height: 1.02573,
    rx: 0.512866,
    fill: "#98929F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9219,
    y: 11.0029,
    width: 5.98448,
    height: 1.02573,
    rx: 0.512866,
    fill: "#98929F"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11.9062,
    y: 13.9963,
    width: 8.01573,
    height: 1.02573,
    rx: 0.512866,
    fill: "#98929F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_715_15987",
    x: 12.8438,
    y: 1.17401,
    width: 6.92383,
    height: 28.889,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.75,
    dy: -0.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.847059 0 0 0 0 0.556863 0 0 0 0 0.403922 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_15987"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2,
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.745098 0 0 0 0 0.458824 0 0 0 0 0.415686 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_715_15987",
    result: "effect2_innerShadow_715_15987"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_715_15987",
    x: 12.6758,
    y: 17.8243,
    width: 6.64844,
    height: 2.12708,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_715_15987"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_iii_715_15987",
    x: 4.69531,
    y: 4.79065,
    width: 22.4648,
    height: 14.4758,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.175
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.584314 0 0 0 0 0.54902 0 0 0 0 0.615686 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_15987"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.175
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.498039 0 0 0 0 0.623529 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_715_15987",
    result: "effect2_innerShadow_715_15987"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.25,
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.909804 0 0 0 0 0.886275 0 0 0 0 0.933333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_715_15987",
    result: "effect3_innerShadow_715_15987"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_715_15987",
    x1: 15.9309,
    y1: 1.92401,
    x2: 15.9309,
    y2: 30.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBD85"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_715_15987",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.4756 22.625) rotate(-2.86242) scale(5.00625 15.1233)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAA470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAA470",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_715_15987",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.5068 2.84375) rotate(144.765) scale(6.93329 8.60666)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397545,
    stopColor: "#FFEBA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEBA0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_715_15987",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.3506 18.8125) rotate(90) scale(9.75 1.5625)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC281",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_715_15987",
    x1: 26.2899,
    y1: 15.25,
    x2: 4.94531,
    y2: 15.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8CFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6BECF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlacard);
export default __webpack_public_path__ + "static/media/Placard.3d44b959b04eab52b39c4cbcef8a6664.svg";
export { ForwardRef as ReactComponent };